module.exports = __webpack_public_path__ + "static/img/no-order.39405515.png";